import { enhancedClientStorage } from '@/scripts/storage/client';

export const userStorage_client = enhancedClientStorage.getModule('user');
export const mediaCS = enhancedClientStorage.getModule('media');
